import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import TruckColorIcon from '../../../../../../../common/icons/icr_envio.svg';

import MotiveTitle from '../MotiveTitle';
import GoldSilverPaymentForm from '../../../forms/goldSilverPayment/GoldSilverPaymentForm';

const GoldSilverPaymentFormMobile = ({ ...props }) => {
  const { motiveId, product, profile, onData } = props;

  return (
    <Box>
      <MotiveTitle
        icon={TruckColorIcon}
        title="Despacho y retiro"
        subtitle="Cambiar dirección de despacho"
        mobile
      />
      <GoldSilverPaymentForm
        mobile
        motiveId={motiveId}
        product={product}
        profile={profile}
        type="1"
        onData={onData}
      />
    </Box>
  );
};

GoldSilverPaymentFormMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default GoldSilverPaymentFormMobile;
